import { render, staticRenderFns } from "./brandModalUpdate.vue?vue&type=template&id=389ff554&scoped=true&"
import script from "./brandModalUpdate.vue?vue&type=script&lang=js&"
export * from "./brandModalUpdate.vue?vue&type=script&lang=js&"
import style0 from "./brandModalUpdate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./brandModalUpdate.vue?vue&type=style&index=1&id=389ff554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ff554",
  null
  
)

export default component.exports